/**
 * Generato automaticamente.
 * OpenAPI
 */

export type GetTipiDomandaStato =
  (typeof GetTipiDomandaStato)[keyof typeof GetTipiDomandaStato];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetTipiDomandaStato = {
  BOZZA: 'BOZZA',
  PRONTA: 'PRONTA',
  COLLAUDO: 'COLLAUDO',
  PUBBLICATA: 'PUBBLICATA',
  APERTA: 'APERTA',
  IN_CORSO: 'IN_CORSO',
  SOSPESA: 'SOSPESA',
  ANNULLATA: 'ANNULLATA',
  CHIUSA: 'CHIUSA',
} as const;
